
export function anchorPopupToSource(popup: HTMLElement, source?: HTMLElement): void {
  if (!popup) {
    return;
  }
  const padding = 8;
  const main =
    typeof document !== 'undefined' ? document.getElementById('layout-main-content') : null;
  const bounds = main
    ? main.getBoundingClientRect()
    : { left: 0, top: 0, right: window.innerWidth, bottom: window.innerHeight };

  const r = popup.getBoundingClientRect();
  let l;
  let t;

  if (source) {
    const src = source.getBoundingClientRect();
    l = src.left;
    t = src.bottom;
  } else {
    l = r.left;
    t = r.top;
  }

  popup.style.position = 'fixed';
  popup.style.zIndex = '20100';

  const maxW = bounds.right - bounds.left - padding * 2;
  if (r.width > maxW && maxW > 0) {
    popup.style.maxWidth = maxW + 'px';
  }

  if (l + r.width > bounds.right - padding) {
    l = bounds.right - padding - r.width;
  }
  if (l < bounds.left + padding) {
    l = bounds.left + padding;
  }
  if (t + r.height > bounds.bottom - padding) {
    t = (source ? source.getBoundingClientRect().top : r.top) - r.height;
  }
  if (t < bounds.top + padding) {
    t = bounds.top + padding;
  }

  popup.style.left = l + 'px';
  popup.style.top = t + 'px';
}

export function anchoredPopup(params: { ePopup?: HTMLElement; eventSource?: HTMLElement }): void {
  if (params && params.ePopup) {
    anchorPopupToSource(params.ePopup, params.eventSource);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/ag-grid-popup.util.ts